export default {"src":"/_next/static/media/wallet_svgrepo_large.com.8151d7bf.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};